module.exports = __webpack_public_path__ + "img/editorial.537e4fc.png";